import { ChangeStartDateRequestType } from 'src/components/common/Modal/СhangeDate';
import { CampaignProfile } from 'src/models/Account/CampaignProfile';
import {
  AccountOrganizerAuthorizationOrder,
  AccountOrganizerClientSecret,
  AccountOrganizerProcessTeamMembersRequestType,
  AccountOrganizerProcessTeamMembersResponseType,
  AccountOrganizerTransactionDetailsResponseType,
} from 'src/models/Account/Organizer';
import {
  AccountOrganizerDeleteTeamsType,
  AccountOrganizerTeamsDataPageType,
  AccountOrganizerTeamsListRequestType,
  AccountOrganizerTeamsListType,
} from 'src/models/Account/Organizer/Teams';
import { APIExportStartReturnType } from 'src/models/BaseApi';
import {
  MyCampaignCopyResponseType,
  MyCampaignCopyType,
  MyCampaignLoadCopyResponseType,
  MyCampaignsListFilterType,
  MyCampaignsListItemType,
} from 'src/models/Campaigns/MyCampaigns';
import { ImportFileResultResponseType } from 'src/models/ImportFileResult';
import { SendEmailToSelectedUserRequestType, SendEmailToSelectedUserResponseType } from 'src/models/Modals/SendEmail';
import { CommonTableRequestType, CommonTableResponseType } from 'src/models/Table';
import {
  AccountOrganizerMembersDataPageType,
  AccountOrganizerMembersDeleteTeamMembersRequestType,
  AccountOrganizerMembersDeleteTeamMembersResponseType,
  AccountOrganizerMembersListItemType,
  AccountOrganizerMembersListRequestType,
  AccountOrganizerMembersListType,
  AccountOrganizerMembersPreviewImportMembersRequestType,
  ResendInvitationRequestType,
  ResendInvitationResponseType,
} from 'src/pages/Account/Organizer/Members/model';
import {
  AccountOrganizerRaffleWinnerDrawWinnerRequestType,
  AccountOrganizerRaffleWinnerDrawWinnerResponseType,
  AccountOrganizerRaffleWinnersDataPageType,
  AccountOrganizerRaffleWinnersFindSupporterByTicketNumberRequestType,
  AccountOrganizerRaffleWinnersFindSupporterByTicketNumberResponseType,
  AccountOrganizerRaffleWinnersListRequestType,
  AccountOrganizerRaffleWinnersListType,
  AccountOrganizerRaffleWinnersRedrawReasonRequestType,
  AccountOrganizerRaffleWinnersRedrawReasonResponseType,
  AccountOrganizerSaveManualDrawingWinnerRequestType,
  AccountOrganizerSaveManualDrawingWinnerResponseType,
} from 'src/pages/Account/Organizer/RaffleWinners/model';
import {
  ApiFunctionNoParamType,
  ApiFunctionType,
  httpGet,
  httpGetCancellable,
  httpPost,
  httpPostCancellable,
} from 'src/utils/http';
import {
  AccountOrganizerExternalContributionListRequestType,
  AccountOrganizerExternalContributionListResponseType,
  AccountOrganizerExternalContributionLoadRequestType,
  AccountOrganizerExternalContributionLoadResponseType,
  AccountOrganizerExternalContributionsLimitModelType,
  AccountOrganizerExternalContributionsListItemType,
  AccountOrganizerExternalContributionsModelType,
  AccountOrganizerGetExternalSupporterInfoByEmailRequestType,
  AccountOrganizerGetExternalSupporterInfoByEmailResponseType,
} from 'src/models/Account/Organizer/externalContributions';
import { CancelDonationModalRequestType } from 'src/models/Modals/cancelDonation';
import { RefundReasonModalResponseType } from 'src/models/Modals/refundReason';
import { FailedReasonResponseType } from 'src/models/Modals/failedReason';
import {
  AccountOrganizerContributionsChangeAuthorizationOrderRequestType,
  AccountOrganizerContributionsChangePaymentMethodRequestType,
  AccountOrganizerContributionsDeliveredRequestType,
  AccountOrganizerContributionsDonationsExportRequestType,
  AccountOrganizerContributionsListRequestType,
  AccountOrganizerContributionsListType,
  AccountOrganizerContributionsRecurringContributionEditPayPalResponse,
  AccountOrganizerContributionsRecurringContributionEditStripeResponse,
  AccountOrganizerContributionsRecurringContributionsExportRequestType,
  AccountOrganizerContributionsRecurringContributionsListRequestType,
  AccountOrganizerContributionsRecurringContributionsListType,
  AccountOrganizerContributionsRecurringListType,
} from 'src/models/Account/Organizer/contributions/donations';
import {
  AccountOrganizerContributionsSupportersListRequestType,
  AccountOrganizerContributionsSupportersListType,
  AccountOrganizerContributionsSupportersViewResponseType,
} from 'src/models/Account/Organizer/contributions/supporters';
import { ViewDetailsModalResponseType } from 'src/models/Modals/viewDetails';
import { CancelRecurringDonationResponseType } from 'src/models/Modals/cancelRecurringDonation';
import {
  AccountOrganizerContributionsResponseType,
  AccountOrganizerGetContributionsParamsType,
} from 'src/models/Account/Organizer/contributions';
import { objectToFormData } from 'src/utils/objectToFormData';
import {
  AccountOrganizerEventRegistrationCheckedInRequest,
  AccountOrganizerEventRegistrationCheckInByQrCodeRequestType,
  AccountOrganizerEventRegistrationCheckInByQrCodeResponseType,
  AccountOrganizerEventRegistrationsCsvRequestType,
  AccountOrganizerEventRegistrationsListType,
  AccountOrganizerEventRegistrationsRequestType,
  AccountOrganizerEventRegistrationsTableRequestType,
  AccountOrganizerRegistrationResendRequestType,
} from 'src/models/Account/Organizer/eventRegistrations';

import {
  AccountOrganizerManualContributionsListItemType,
  AccountOrganizerManualContributionsListType,
} from 'src/models/Account/Organizer/manualContributions';
import { numberOrDefaultNumber } from 'src/utils/numbers';
import { MyAccountTableTeamsListItemType } from 'src/models/Account/MyAccount/tableTabs/teams';
import {
  AccountOrganizerEventGroupRegistrationDeleteRequest,
  AccountOrganizerEventGroupRegistrationFindEventRequest,
  AccountOrganizerEventGroupRegistrationLoadGroupRequest,
  AccountOrganizerEventGroupRegistrationLoadGroupResponse,
  AccountOrganizerEventGroupRegistrationSaveGroupRequest,
  AccountOrganizerEventGroupRegistrationsCsvRequestType,
  AccountOrganizerEventGroupRegistrationsListType,
  AccountOrganizerEventGroupRegistrationsLoadRequestType,
  AccountOrganizerEventGroupRegistrationsRequestType,
  AccountOrganizerGroupRegistrationsLoadCustomFieldValuesResponseType,
} from 'src/models/Account/Organizer/eventGroupRegistrations';
import {
  AccountOrganizerNewFundRequestType,
  AccountOrganizerNewFundResponseType,
  AccountOrganizerRequestFundsListType,
  AccountOrganizerRequestFundsWithdrawCampaignRequestType,
  AccountOrganizerRequestFundsWithdrawCampaignResponseType,
} from 'src/models/Account/Organizer/requestFunds';
import {
  AccountOrganizerAdministratorsInviteRequestType,
  AccountOrganizerAdministratorsInviteResponseType,
  AccountOrganizerAdministratorsListType,
  AccountOrganizerAdministratorsPageDataType,
  AccountOrganizerAdministratorsRemoveItemRequestType,
} from 'src/models/Account/Organizer/administrators';
import {
  AccountOrganizerEditTicketRequestType,
  AccountOrganizerFindTicketRequestType,
  AccountOrganizerLoadTicketRequestType,
  AccountOrganizerLoadTicketResponseType,
} from 'src/models/Account/Organizer/ticket';
import { AccountOrganizerWidgetWizardResponseType } from 'src/models/Account/Organizer/widgetWizard';
import { AccountOrganizerCrowdfundingRewardsListType } from 'src/models/Account/Organizer/crowdfundingRewards';
import {
  AccountOrganizerDeleteRegisteredDonorRequestType,
  AccountOrganizerEditRegisteredDonorRequestType,
  AccountOrganizerFindRegisteredDonorRequestType,
  AccountOrganizerFindRegisteredDonorResponseType,
  AccountOrganizerRegisteredDonorsListRequestType,
  AccountOrganizerRegisteredDonorsListType,
  AccountOrganizerRegisteredDonorsViewResponseType,
} from 'src/models/Account/Organizer/registeredDonors';
import {
  AccountOrganizerContributionsLedgerListType,
  AccountOrganizerContributionsLedgerRequestType,
} from 'src/models/Account/Organizer/contributions/ledger';
import {
  AccountOrganizerSweepstakesWinnerDrawWinnerRequestType,
  AccountOrganizerSweepstakesWinnerDrawWinnerResponseType,
  AccountOrganizerSweepstakesWinnersListRequestType,
  AccountOrganizerSweepstakesWinnersListType,
  AccountOrganizerSweepstakesWinnersRedrawReasonRequestType,
  AccountOrganizerSweepstakesWinnersRedrawReasonResponseType,
} from 'src/pages/Account/Organizer/SweepstakesWinners/model';

const getPath = (path: string) => `/account/organizer/${path}`;

export const apiSignOut = (
  returnUrl: string | null
): Promise<{
  RedirectUrl: string | null;
}> => httpPost('/LoginDispatcher/signout', { returnUrl });

export const apiGetCampaignProfile: ApiFunctionType<{ ID: number }, CampaignProfile> = httpPostCancellable(
  getPath('campaignProfile')
);

export const apiOrganizerEditStartSellingDate = (
  data: ChangeStartDateRequestType
): Promise<ChangeStartDateRequestType> => httpPost(getPath('editstartsellingdate'), data);

/** get organizer campaign list */
export const apiOrganizerGetCampaignList: ApiFunctionType<
  MyCampaignsListFilterType,
  CommonTableResponseType<MyCampaignsListItemType>
> = httpPostCancellable(getPath('listCampaigns'));

/** copy */
export const apiOrganizerValidateCopyCampaign = (model: MyCampaignCopyType): Promise<MyCampaignCopyResponseType> =>
  httpPost(getPath('validatecopycampaign'), model);

export const apiOrganizerCopyCampaign = (model: MyCampaignCopyType): Promise<MyCampaignCopyResponseType> =>
  httpPost(getPath('copycampaign'), model);

export const apiLoadCopyCampaignModal: ApiFunctionType<{ PermanentUrl: string }, MyCampaignLoadCopyResponseType> =
  httpPostCancellable(getPath('LoadCopyCampaignModal'));
/** copy end */

export const apiMyCampaignExport = (): Promise<APIExportStartReturnType> => httpPost(getPath('campaignscsv'));

/** cancel contribution */
export const apiOrganizerCancelContribution = (
  data: CancelDonationModalRequestType
): Promise<CancelDonationModalRequestType> => httpPost(getPath('cancelpayment'), data);

/** cancel contribution refund reason */
export const apiLoadContributionRefundReason: ApiFunctionType<{ PaymentID: number }, RefundReasonModalResponseType> =
  httpPostCancellable(getPath('LoadContributionRefundReason'));

/** turn on/off a campaign */
export const apiChangeDonationAbility = (data: {
  PermanentUrl: string;
  IsDonationAllowed: boolean;
}): Promise<unknown> => httpPost(getPath('changedonationability'), data);

export const apiOrganizerLoadExternalContributions = (
  data: AccountOrganizerExternalContributionListRequestType
): Promise<AccountOrganizerExternalContributionListResponseType> =>
  httpPost(getPath('loadexternalcontributions'), data);

export const apiExternalContributionsCsv = (permanentUrl: string): Promise<APIExportStartReturnType> =>
  httpPost(getPath('externalcontributionscsv'), { permanentUrl });

export const apiLoadExternalContribution = (
  data: AccountOrganizerExternalContributionLoadRequestType
): Promise<AccountOrganizerExternalContributionLoadResponseType> => httpPost(getPath('loadexternalcontribution'), data);

export const apiGetExternalSupporterInfoByEmail = (
  data: AccountOrganizerGetExternalSupporterInfoByEmailRequestType
): Promise<AccountOrganizerGetExternalSupporterInfoByEmailResponseType> =>
  httpPost(getPath('getexternalsupporterinfobyemail'), data);

export const apiSaveExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> => httpPost(getPath('SaveExternalContribution'), data);

export const apiCompleteTestModeCreditCardExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('completetestmodecreditcardexternalcontribution'), data);

export const apiCreateOrUpdateCreditCardExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('createorupdatecreditcardexternalcontribution'), data);

export const apiCompleteCreditCardExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('completecreditcardexternalcontribution'), data);

export const apiDeleteExternalContribution = (
  data: AccountOrganizerExternalContributionsListItemType
): Promise<AccountOrganizerExternalContributionsListItemType> => httpPost(getPath('deleteexternalcontribution'), data);

export const apiVerifyExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('verifyexternalcontribution'), data);

export const apiCreateOrUpdateTestModeCreditCardExternalContribution = (
  data: AccountOrganizerExternalContributionLoadResponseType
): Promise<AccountOrganizerExternalContributionLoadResponseType> =>
  httpPost(getPath('createorupdatetestmodecreditcardexternalcontribution'), data);

export const apiGetExternalContributions: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerExternalContributionsModelType
> = httpGetCancellable(getPath('GetExternalContributions'));

export const apiLoadCampaignOutsideDonationLimitModel: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerExternalContributionsLimitModelType
> = httpPostCancellable(getPath('LoadCampaignOutsideDonationLimitModel'));

export const apiGetOrganizerTransactionDetails = (
  PaymentID: number
): Promise<AccountOrganizerTransactionDetailsResponseType> =>
  httpPost(getPath('viewtransactiondetails'), { PaymentID });

export const apiLoadContributionFailedReason = (PaymentID: number): Promise<FailedReasonResponseType> =>
  httpPost(getPath('LoadContributionFailedReason'), { PaymentID });

export const apiViewContributionsTable = (
  data: AccountOrganizerContributionsListRequestType
): Promise<AccountOrganizerContributionsListType> => httpPost(getPath('ViewContributionsTable'), data);

export const apiViewRecurringContributionsTable = (
  data: AccountOrganizerContributionsRecurringContributionsListRequestType
): Promise<AccountOrganizerContributionsRecurringContributionsListType> =>
  httpPost(getPath('ViewRecurringContributionsTable'), data);

export const apiLoadContributions = (
  data: AccountOrganizerContributionsListRequestType
): Promise<AccountOrganizerContributionsListType> => httpPost(getPath('LoadContributions'), data);

export const apiLoadRecurringContributions = (
  data: AccountOrganizerContributionsListRequestType
): Promise<AccountOrganizerContributionsRecurringListType> => httpPost(getPath('LoadRecurringContributions'), data);

export const apiLoadSupporters = (
  data: AccountOrganizerContributionsSupportersListRequestType
): Promise<AccountOrganizerContributionsSupportersListType> => httpPost(getPath('LoadSupporters'), data);

export const apiViewSupportersTable = (
  data: AccountOrganizerContributionsSupportersListRequestType
): Promise<AccountOrganizerContributionsSupportersViewResponseType> => httpPost(getPath('ViewSupportersTable'), data);

export const apiContributionsCsv = (
  data: AccountOrganizerContributionsDonationsExportRequestType
): Promise<APIExportStartReturnType> => httpPost(getPath('ContributionsCsv'), data);

export const apiRecurringContributionsCsv = (
  data: AccountOrganizerContributionsRecurringContributionsExportRequestType
): Promise<APIExportStartReturnType> => httpPost(getPath('RecurringContributionsCsv'), data);

export const apiSupportersCsv = (permanentUrl: string): Promise<APIExportStartReturnType> =>
  httpPost(getPath('SupportersCsv'), { permanentUrl });

export const apiSendEmailToSelectedUsers: ApiFunctionType<
  SendEmailToSelectedUserRequestType,
  SendEmailToSelectedUserResponseType
> = httpPostCancellable(getPath('SendEmailToSelectedUsers'));

export const apiLoadCancelRecurringContributionDialog: ApiFunctionType<
  { ContributionID: number },
  CancelRecurringDonationResponseType
> = httpPostCancellable(getPath('LoadCancelRecurringContributionDialog'));

export const apiCancelRecurringContribution: ApiFunctionType<
  { ContributionID: number },
  CancelRecurringDonationResponseType
> = httpPostCancellable(getPath('CancelRecurringContribution'));

export const apiLoadEditRecurringContributionStripeDialog = (
  ContributionID: number
): Promise<AccountOrganizerContributionsRecurringContributionEditStripeResponse> =>
  httpPost(getPath('LoadEditRecurringContributionStripeDialog'), { ContributionID });

export const apiLoadEditRecurringContributionPayPalDialog = (
  ContributionID: number
): Promise<AccountOrganizerContributionsRecurringContributionEditPayPalResponse> =>
  httpPost(getPath('LoadEditRecurringContributionPayPalDialog'), { ContributionID });

export const apiPrepareSetupIntent = (ContributionID: number): Promise<AccountOrganizerClientSecret> =>
  httpPost(getPath('PrepareSetupIntent'), { ContributionID });

export const apiChangePaymentMethod = (
  data: AccountOrganizerContributionsChangePaymentMethodRequestType
): Promise<boolean> => httpPost(getPath('ChangePaymentMethod'), data);

export const PrepareAuthorizationOrder = (ContributionID: number): Promise<AccountOrganizerAuthorizationOrder> =>
  httpPost(getPath('PrepareAuthorizationOrder'), { ContributionID });

export const apiChangeAuthorizationOrder = (
  data: AccountOrganizerContributionsChangeAuthorizationOrderRequestType
): Promise<boolean> => httpPost(getPath('ChangeAuthorizationOrder'), data);

export const apiMarkItemsDelivered: ApiFunctionType<AccountOrganizerContributionsDeliveredRequestType, boolean> =
  httpPostCancellable(getPath('MarkItemsDelivered'));

export const apiUnmarkItemsDelivered: ApiFunctionType<AccountOrganizerContributionsDeliveredRequestType, boolean> =
  httpPostCancellable(getPath('UnmarkItemsDelivered'));

export const apiGetContributions: ApiFunctionType<
  AccountOrganizerGetContributionsParamsType,
  AccountOrganizerContributionsResponseType
> = httpGetCancellable(getPath('GetContributions'));

export const apiGetOrganizerMembers: ApiFunctionType<
  AccountOrganizerMembersListRequestType,
  AccountOrganizerMembersListType
> = httpPostCancellable(getPath('loadMembers'));

export const apiOrganizerMembersGetPageInfo: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerMembersDataPageType
> = httpGetCancellable(getPath('getMembers'));

export const apiOrganizerMembersToggleCheckedIn: ApiFunctionType<
  { ID: number; IsCheckedIn: boolean },
  AccountOrganizerMembersListItemType
> = httpPostCancellable(getPath('toggleCheckedIn'));

export const apiOrganizerMembersDeleteTeamMembers: ApiFunctionType<
  AccountOrganizerMembersDeleteTeamMembersRequestType,
  AccountOrganizerMembersDeleteTeamMembersResponseType
> = httpPostCancellable(getPath('deleteTeamMembers'));

export const apiOrganizerMembersResendInvitation: ApiFunctionType<
  ResendInvitationRequestType,
  ResendInvitationResponseType
> = httpPostCancellable(getPath('resendMemberThankYouEmails'));

export const apiOrganizerTeamsResendInvitation: ApiFunctionType<
  ResendInvitationRequestType,
  ResendInvitationResponseType
> = httpPostCancellable(getPath('resendTeamThankYouEmails'));

export const apiOrganizerPreviewImportMembers = ({
  permanentUrl,
  registrationTypeId,
  file,
}: AccountOrganizerMembersPreviewImportMembersRequestType): Promise<ImportFileResultResponseType> =>
  httpPost(
    getPath(
      `previewImportTeamMembers?permanentUrl=${permanentUrl}${
        registrationTypeId ? `&registrationTypeId=${registrationTypeId}` : ''
      }`
    ),
    objectToFormData({
      file_data: file,
    })
  );

export const apiGetEventRegistrations: ApiFunctionType<
  AccountOrganizerEventRegistrationsRequestType,
  AccountOrganizerEventRegistrationsListType
> = httpGetCancellable(getPath('GetEventRegistrations'));

export const apiLoadEventRegistrations: ApiFunctionType<
  AccountOrganizerEventRegistrationsTableRequestType,
  AccountOrganizerEventRegistrationsListType
> = httpPostCancellable(getPath('LoadEventRegistrations'));

export const apiEventRegistrationsCsv: ApiFunctionType<
  AccountOrganizerEventRegistrationsCsvRequestType,
  APIExportStartReturnType
> = httpPostCancellable(getPath('EventRegistrationsCsv'));

export const apiSetEventRegistrationCheckedIn: ApiFunctionType<
  AccountOrganizerEventRegistrationCheckedInRequest,
  AccountOrganizerEventRegistrationCheckedInRequest
> = httpPostCancellable(getPath('SetEventRegistrationCheckedIn'));

export const apiLoadEventRegistration: ApiFunctionType<
  AccountOrganizerLoadTicketRequestType,
  AccountOrganizerLoadTicketResponseType
> = httpPostCancellable(getPath('LoadEventRegistration'));

export const apiLoadEventRegistrationForMoving: ApiFunctionType<
  AccountOrganizerLoadTicketResponseType,
  AccountOrganizerLoadTicketResponseType
> = httpPostCancellable(getPath('LoadEventRegistrationForMoving'));

export const apiFindEventGroupRegistration: ApiFunctionType<
  AccountOrganizerFindTicketRequestType,
  AccountOrganizerFindTicketRequestType
> = httpPostCancellable(getPath('FindEventGroupRegistration'));

export const apiSaveEventRegistration: ApiFunctionType<
  AccountOrganizerEditTicketRequestType,
  AccountOrganizerEditTicketRequestType
> = httpPostCancellable(getPath('SaveEventRegistration'));

export const apiProcessTeamMembers: ApiFunctionType<
  AccountOrganizerProcessTeamMembersRequestType,
  AccountOrganizerProcessTeamMembersResponseType
> = httpPostCancellable(getPath('processTeamMembers'));

/** export */
export const apiExportMembers: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('membersCsv'));

export const apiExportMemberPrizeWinners: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('prizeWinnersCsv'));
/** end export */

export const apiGetManualContributions: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerManualContributionsListType
> = (data) =>
  httpGet(getPath('GetManualContributions'), data).then((response) => ({
    ...response,
    TotalRecordsCount: numberOrDefaultNumber(response?.Items.length),
  }));

export const apiManualContributionsCsv: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('ManualContributionsCsv'));

export const apiCancelManualContribution: ApiFunctionType<
  AccountOrganizerManualContributionsListItemType,
  AccountOrganizerManualContributionsListItemType
> = httpPostCancellable(getPath('CancelManualContribution'));

export const apiLoadManualContributions: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerManualContributionsListType
> = (data) =>
  httpPost(getPath('LoadManualContributions'), data).then((response) => ({
    ...response,
    Items: response?.Items.map((item: AccountOrganizerManualContributionsListItemType) => ({
      ...item,
      supporterName: `${item.SupporterFirstName} ${item.SupporterLastName}`,
    })),
    TotalRecordsCount: numberOrDefaultNumber(response?.Items.length),
  }));

export const apiSaveManualContribution: ApiFunctionType<
  AccountOrganizerManualContributionsListItemType,
  AccountOrganizerManualContributionsListItemType
> = httpPostCancellable(getPath('SaveManualContribution'));

/** teams */
export const apiGetTeamsPageData: ApiFunctionType<{ permanentUrl: string }, AccountOrganizerTeamsDataPageType> =
  httpGetCancellable(getPath('GetTeamsPageData'));

export const apiGetTeams: ApiFunctionType<AccountOrganizerTeamsListRequestType, AccountOrganizerTeamsListType> =
  httpPostCancellable(getPath('loadTeams'));

export const apiDeleteTeams: ApiFunctionType<AccountOrganizerDeleteTeamsType, AccountOrganizerDeleteTeamsType> =
  httpPostCancellable(getPath('deleteTeams'));

export const apiOrganizerPreviewImportTeams = ({
  permanentUrl,
  registrationTypeId,
  file,
}: AccountOrganizerMembersPreviewImportMembersRequestType): Promise<ImportFileResultResponseType> =>
  httpPost(
    getPath(
      `previewImportTeams?permanentUrl=${permanentUrl}${
        registrationTypeId ? `&registrationTypeId=${registrationTypeId}` : ''
      }`
    ),
    objectToFormData({
      file_data: file,
    })
  );

export const apiProcessTeams: ApiFunctionType<
  AccountOrganizerProcessTeamMembersRequestType,
  AccountOrganizerProcessTeamMembersResponseType
> = httpPostCancellable(getPath('processTeams'));

export const apiExportTeams: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> = httpPostCancellable(
  getPath('teamsCsv')
);

export const apiExportTeamPrizeWinners: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('TeamWinnersCsv'));

export const apiExportTeamContributions: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('ContributionsCsv'));
/** end teams */

export const apiLoadDashboardTeam: ApiFunctionType<
  { permanentUrl?: string; teamId: string | number },
  MyAccountTableTeamsListItemType
> = httpPostCancellable(getPath('LoadDashboardTeam'));

/* event group registration */
export const apiGetEventGroupRegistrations: ApiFunctionType<
  AccountOrganizerEventGroupRegistrationsRequestType,
  AccountOrganizerEventGroupRegistrationsListType
> = httpGetCancellable(getPath('GetEventGroupRegistrations'));

export const apiLoadEventGroupRegistrations: ApiFunctionType<
  AccountOrganizerEventGroupRegistrationsLoadRequestType,
  AccountOrganizerEventGroupRegistrationsListType
> = httpPostCancellable(getPath('LoadEventGroupRegistrations'));

export const apiEventGroupRegistrationsCsv: ApiFunctionType<
  AccountOrganizerEventGroupRegistrationsCsvRequestType,
  APIExportStartReturnType
> = httpPostCancellable(getPath('EventGroupRegistrationsCsv'));

export const apiLoadEventGroupRegistration: ApiFunctionType<
  AccountOrganizerEventGroupRegistrationLoadGroupRequest,
  AccountOrganizerEventGroupRegistrationLoadGroupResponse
> = httpPostCancellable(getPath('LoadEventGroupRegistration'));

export const apiLoadEventRegistrationCustomFieldValues: ApiFunctionType<
  Pick<
    AccountOrganizerGroupRegistrationsLoadCustomFieldValuesResponseType,
    'RegistrationID' | 'CurrentTicketGroupRegistrationID'
  >,
  AccountOrganizerGroupRegistrationsLoadCustomFieldValuesResponseType
> = httpPostCancellable(getPath('LoadEventRegistrationCustomFieldValues'));

export const apiSaveEventGroupRegistration: ApiFunctionType<
  AccountOrganizerEventGroupRegistrationSaveGroupRequest,
  AccountOrganizerEventGroupRegistrationSaveGroupRequest
> = httpPostCancellable(getPath('SaveEventGroupRegistration'));

export const apiFindEventRegistration: ApiFunctionType<
  AccountOrganizerEventGroupRegistrationFindEventRequest,
  AccountOrganizerEventGroupRegistrationFindEventRequest
> = httpPostCancellable(getPath('FindEventRegistration'));

export const apiGenerateUniquePermanentUrlForInvitation: ApiFunctionNoParamType<string> = httpPostCancellable(
  getPath('GenerateUniquePermanentUrlForInvitation')
);

export const apiUnInviteRegistration: ApiFunctionType<{ RegistrationID: number }, { RegistrationID: number }> =
  httpPostCancellable(getPath('UninviteRegistration'));

export const apiRemoveRegistration: ApiFunctionType<{ RegistrationID: number }, { RegistrationID: number }> =
  httpPostCancellable(getPath('RemoveRegistration'));

export const apiUnInviteGroupRegistration: ApiFunctionType<
  AccountOrganizerEventGroupRegistrationDeleteRequest,
  AccountOrganizerEventGroupRegistrationDeleteRequest
> = httpPostCancellable(getPath('UnInviteGroupRegistration'));
/* end event group registration */

/* fund requests */
export const apiLoadFundRequests: ApiFunctionType<{ permanentUrl: string }, AccountOrganizerRequestFundsListType> =
  httpPostCancellable(getPath('LoadFundRequests'));

export const apiNewFundRequest: ApiFunctionType<
  AccountOrganizerNewFundRequestType,
  AccountOrganizerNewFundResponseType
> = httpPostCancellable(getPath('NewFundRequest'));

export const apiLoadWithdrawCampaignFundModel: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerRequestFundsWithdrawCampaignResponseType
> = httpPostCancellable(getPath('LoadWithdrawCampaignFundModel'));

export const apiNewFundRequestWithFundingDataSaving: ApiFunctionType<
  AccountOrganizerRequestFundsWithdrawCampaignResponseType,
  AccountOrganizerRequestFundsWithdrawCampaignRequestType
> = httpPostCancellable(getPath('NewFundRequestWithFundingDataSaving'));

export const apiRequestFundsCsv: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('RequestFundsCsv'));
/* fund requests end */

/* administrators */
export const apiGetAdministrators: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerAdministratorsPageDataType
> = httpGetCancellable(getPath('GetAdministrators'));

export const apiLoadAdministrators: ApiFunctionType<{ permanentUrl: string }, AccountOrganizerAdministratorsListType> =
  httpPostCancellable(getPath('LoadAdministrators'));

export const apiRemoveAdministrator: ApiFunctionType<
  AccountOrganizerAdministratorsRemoveItemRequestType,
  AccountOrganizerAdministratorsRemoveItemRequestType
> = httpPostCancellable(getPath('RemoveAdministrator'));

export const apiInviteAdministrators: ApiFunctionType<
  AccountOrganizerAdministratorsInviteRequestType,
  AccountOrganizerAdministratorsInviteResponseType
> = httpPostCancellable(getPath('InviteAdministrators'));

export const apiAdministratorsCsv: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('AdministratorsCsv'));
/* administrators end */

export const apiGetOrganizerRaffleWinnersList: ApiFunctionType<
  AccountOrganizerRaffleWinnersListRequestType,
  AccountOrganizerRaffleWinnersListType
> = httpPostCancellable(getPath('loadRaffleWinners'));

export const apiCheckDrawingProcessFinished: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerRaffleWinnersDataPageType
> = httpPostCancellable(getPath('checkDrawingProcessFinished'));

export const apiRaffleDrawingWinnersCSV: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('raffleDrawingWinnersCsv'));

export const apiRaffleDrawingWinner: ApiFunctionType<
  AccountOrganizerRaffleWinnerDrawWinnerRequestType,
  AccountOrganizerRaffleWinnerDrawWinnerResponseType
> = httpPostCancellable(getPath('redrawRaffleWinner'));

export const apiLoadRaffleRedrawReason: ApiFunctionType<
  AccountOrganizerRaffleWinnersRedrawReasonRequestType,
  AccountOrganizerRaffleWinnersRedrawReasonResponseType
> = httpPostCancellable(getPath('loadRaffleRedrawReason'));

/** draw winners */
export const apiDrawRaffleWinners: ApiFunctionType<{ PermanentUrl: string }, unknown> = httpPostCancellable(
  getPath('drawRaffleWinners')
);

export const apiDrawSweepstakeWinners: ApiFunctionType<{ PermanentUrl: string }, unknown> = httpPostCancellable(
  getPath('drawSweepstakesWinners')
);
/** end draw winners */

export const apiGetRaffleWinnersPageData: ApiFunctionType<
  { PermanentUrl: string },
  AccountOrganizerRaffleWinnersDataPageType
> = httpGetCancellable(getPath('GetRaffleWinners'));

export const apiNotifyDrawingWinners: ApiFunctionType<{ permanentUrl: string }, string> = httpGetCancellable(
  getPath('notifyDrawingWinners')
);

export const apiFindSupporterByTicketNumber: ApiFunctionType<
  AccountOrganizerRaffleWinnersFindSupporterByTicketNumberRequestType,
  AccountOrganizerRaffleWinnersFindSupporterByTicketNumberResponseType
> = httpPostCancellable(getPath('findSupporterByTicketNumber'));

export const apiSaveManualDrawingWinner: ApiFunctionType<
  AccountOrganizerSaveManualDrawingWinnerRequestType,
  AccountOrganizerSaveManualDrawingWinnerResponseType
> = httpPostCancellable(getPath('saveManualDrawingWinner'));

/** widget wizard */
export const apiLoadWidgetWizard: ApiFunctionType<{ permanentUrl: string }, AccountOrganizerWidgetWizardResponseType> =
  httpGetCancellable(getPath('LoadWidgetWizard'));

export const apiSaveWidget: ApiFunctionType<
  AccountOrganizerWidgetWizardResponseType,
  AccountOrganizerWidgetWizardResponseType
> = httpPostCancellable(getPath('SaveWidget'));
/* widget wizard end */

export const apiCheckInByQrCode: ApiFunctionType<
  AccountOrganizerEventRegistrationCheckInByQrCodeRequestType,
  AccountOrganizerEventRegistrationCheckInByQrCodeResponseType
> = httpPostCancellable(getPath('CheckInByQrCode'));

/** crowdfunding rewards */
export const apiLoadCrowdfundingRewardsView: ApiFunctionType<
  { permanentUrl: string },
  AccountOrganizerCrowdfundingRewardsListType
> = httpGetCancellable(getPath('LoadCrowdfundingRewardsView'));

export const apiLoadCrowdfundingRewards: ApiFunctionType<
  CommonTableRequestType,
  AccountOrganizerCrowdfundingRewardsListType
> = httpPostCancellable(getPath('LoadCrowdfundingRewards'));

export const apiCrowdfundingRewardsTableCsv: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('CrowdfundingRewardsTableCsv'));
/** crowdfunding rewards end */

export const apiResendRegistrationEmailToRecipient: ApiFunctionType<
  AccountOrganizerRegistrationResendRequestType,
  { RegistrationID: number }
> = httpPostCancellable(getPath('ResendRegistrationEmailToRecipient'));

export const apiLoadRegisteredDonors = (
  data: AccountOrganizerRegisteredDonorsListRequestType
): Promise<AccountOrganizerRegisteredDonorsListType> => httpPost(getPath('LoadRegisteredDonors'), data);

export const apiViewRegisteredDonorsTable = (
  data: AccountOrganizerRegisteredDonorsListRequestType
): Promise<AccountOrganizerRegisteredDonorsViewResponseType> => httpPost(getPath('ViewRegisteredDonorsTable'), data);

export const apiRegisteredDonorsCsv = (permanentUrl: string): Promise<APIExportStartReturnType> =>
  httpPost(getPath('RegisteredDonorsCsv'), { permanentUrl });

export const apiLoadRegisteredDonor: ApiFunctionType<
  AccountOrganizerFindRegisteredDonorRequestType,
  AccountOrganizerFindRegisteredDonorResponseType
> = httpPostCancellable(getPath('LoadPreRegistration'));

export const apiSaveRegisteredDonor: ApiFunctionType<
  AccountOrganizerEditRegisteredDonorRequestType,
  AccountOrganizerEditRegisteredDonorRequestType
> = httpPostCancellable(getPath('EditPreRegistration'));

export const apiDeleteRegisteredDonor: ApiFunctionType<
  AccountOrganizerDeleteRegisteredDonorRequestType,
  AccountOrganizerDeleteRegisteredDonorRequestType
> = httpPostCancellable(getPath('DeletePreRegistration'));

export const apiGetOrganizerDonorDetails = (PreRegistrationID: number): Promise<ViewDetailsModalResponseType> =>
  httpPost(getPath('LoadDonorDetails'), { PreRegistrationID });

/** ledger */
export const apiViewLedgerTable: ApiFunctionType<
  AccountOrganizerContributionsLedgerRequestType,
  AccountOrganizerContributionsLedgerListType
> = httpPostCancellable(getPath('ViewLedgerTable'));

export const apiLoadLedgerTable: ApiFunctionType<
  AccountOrganizerContributionsLedgerRequestType,
  AccountOrganizerContributionsLedgerListType
> = httpPostCancellable(getPath('LoadLedgerTable'));

export const apiExportLedgerCsv: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('LedgersCsv'));

export const apiExportSubLedgerCsv: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('SubLedgersCsv'));
/** ledger end */

/** sweepstakes */
export const apiGetSweepstakesWinnersPageData = httpGetCancellable(getPath('GetSweepstakesWinners'));

export const apiGetOrganizerSweepstakesWinnersList: ApiFunctionType<
  AccountOrganizerSweepstakesWinnersListRequestType,
  AccountOrganizerSweepstakesWinnersListType
> = httpPostCancellable(getPath('loadSweepstakesWinners'));

export const apiSweepstakesDrawingWinnersCSV: ApiFunctionType<{ permanentUrl: string }, APIExportStartReturnType> =
  httpPostCancellable(getPath('SweepstakesDrawingWinnersCsv'));

export const apiSweepstakesDrawingWinner: ApiFunctionType<
  AccountOrganizerSweepstakesWinnerDrawWinnerRequestType,
  AccountOrganizerSweepstakesWinnerDrawWinnerResponseType
> = httpPostCancellable(getPath('redrawSweepstakesWinner'));

export const apiLoadSweepstakesRedrawReason: ApiFunctionType<
  AccountOrganizerSweepstakesWinnersRedrawReasonRequestType,
  AccountOrganizerSweepstakesWinnersRedrawReasonResponseType
> = httpPostCancellable(getPath('LoadSweepstakesRedrawReason'));
/** sweepstakes end */
